import type { TranslationMap } from '../i18n';

export const de: TranslationMap = {
  // Auth - Common
  'auth.email': 'E-Mail',
  'auth.password': 'Passwort',
  'auth.firstName': 'Vorname',
  'auth.lastName': 'Nachname',
  'auth.back': '← Zurück',
  'auth.acceptTerms': 'Ich akzeptiere die',
  'auth.termsAndConditions': 'Allgemeine Geschäftsbedingungen',
  'auth.verificationRequired': 'Verifizierung erforderlich',
  'auth.verificationLinkSent': 'Bitte klicke auf den Bestätigungslink in deinem Posteingang.',
  'auth.sending': 'Wird gesendet...',
  'auth.resendLink': 'Link erneut senden',
  'auth.phonePlaceholder': '0171 xxxxxxx',

  // Auth - Login
  'auth.signIn': 'Anmelden',
  'auth.signingIn': 'Anmeldung läuft...',
  'auth.resetPassword': 'Passwort zurücksetzen',
  'auth.createAccount': 'Konto erstellen',
  'auth.logIn': 'Anmelden',
  'auth.logInToPurchase': 'Anmelden zum Kaufen',

  // Auth - Account Create
  'auth.zipcodeOptional': 'Postleitzahl (optional)',
  'auth.zipcodePlaceholder': 'Postleitzahl',
  'auth.phoneNumberOptional': 'Telefonnummer (optional)',
  'auth.phoneNumber': 'Telefonnummer',
  'auth.birthdayOptional': 'Geburtstag (optional)',
  'auth.birthday': 'Geburtstag',
  'auth.subscribeToMarketing': 'E-Mail-Marketing abonnieren',
  'auth.create': 'Erstellen',
  'auth.creating': 'Wird erstellt...',
  'auth.alreadyHaveAccount': 'Bereits ein Konto?',

  // Auth - Reset Password
  'auth.submit': 'Absenden',

  // Auth - Errors
  'auth.errorUnableToSignIn': 'Anmeldung fehlgeschlagen. Bitte versuche es erneut.',
  'auth.errorLoginGeneric':
    'Bei der Anmeldung ist ein Fehler aufgetreten. Bitte versuche es erneut.',
  'auth.errorRequiredFields': 'Pflichtfelder fehlen. Bitte fülle das Formular aus.',
  'auth.errorCreateGeneric': 'Ein Fehler ist aufgetreten. Bitte versuche es erneut.',
  'auth.errorCreateAccount':
    'Bei der Kontoerstellung ist ein Fehler aufgetreten. Bitte versuche es erneut.',
  'auth.errorEmailNotFound': 'E-Mail-Feld nicht gefunden. Bitte versuche es erneut.',
  'auth.errorEnterEmail': 'Bitte gib deine E-Mail-Adresse ein.',
  'auth.errorResetPassword':
    'Passwort konnte nicht zurückgesetzt werden. Bitte versuche es erneut.',
  'auth.errorResetGeneric':
    'Beim Zurücksetzen des Passworts ist ein Fehler aufgetreten. Bitte versuche es erneut.',
  'auth.error.login_required':
    'Anmeldung erforderlich. Bitte gib deine E-Mail-Adresse und dein Passwort ein.',
  'auth.error.invalid_credentials':
    'Ungültige E-Mail-Adresse oder ungültiges Passwort. Bitte versuche es erneut.',
  'auth.error.account_already_exists':
    'Ein Konto mit dieser E-Mail-Adresse existiert bereits. Bitte melde dich an.',
  'auth.error.invalid_email':
    'Die eingegebene E-Mail-Adresse ist ungültig. Bitte versuche es erneut.',
  'auth.error.weak_password': 'Dein Passwort ist zu schwach. Bitte wähle ein stärkeres Passwort.',
  'auth.error.missing_fields':
    'Alle Felder sind Pflichtfelder. Bitte fülle das Formular vollständig aus.',
  'auth.error.invalid_name': 'Der eingegebene Name ist ungültig. Bitte verwende nur Buchstaben.',
  'auth.error.password_mismatch': 'Die Passwörter stimmen nicht überein. Bitte versuche es erneut.',
  'auth.error.missing_email': 'Bitte gib deine E-Mail-Adresse ein.',
  'auth.error.email_not_found':
    'Wir konnten kein Konto mit dieser E-Mail-Adresse finden. Bitte überprüfe sie und versuche es erneut.',
  'auth.error.email_verify': 'Bitte bestätige deine E-Mail-Adresse und versuche es erneut.',
  'auth.error.captcha_challenge':
    'Zusätzliche Verifizierung erforderlich. Bitte schließe die Sicherheitsprüfung ab.',
  'auth.error.unknown_error':
    'Ein unbekannter Fehler ist aufgetreten. Bitte versuche es später erneut.',

  // Product
  'product.buyNow': 'Jetzt kaufen',
  'product.soldOut': 'Ausverkauft',
  'product.processing': 'Verarbeitung...',
  'product.errorAddToCart': 'Konnte nicht zum Warenkorb hinzugefügt werden.',

  // Need Access
  'access.logInToWatch': 'Anmelden zum Ansehen',
  'access.purchaseAccess': 'Zugang kaufen',
  'access.joinOrPurchase': 'Tritt der Community bei oder kaufe Zugang',
  'access.noAccess': 'Du hast keinen Zugang zu diesem Inhalt',
  'access.joinToUnlock': 'Beitreten zum Freischalten',
  'access.joinForAccess': 'Beitreten für Zugang',
  'access.locked': 'Gesperrt',
  'access.joinToWatch': 'Beitreten zum Ansehen',
  'access.joinOrPurchaseAccess': 'Beitreten oder Zugang kaufen',
  'access.alreadyPurchased': 'Bereits gekauft?',
  'access.logInWithEmail': 'Mit der für den Kauf verwendeten E-Mail anmelden',
  'access.or': '- oder -',
  'access.noProductsAvailable': 'Derzeit sind keine Produkte verfügbar, die Zugang gewähren',
  'access.upgradeToAccess': 'Upgrade für Zugang',

  // Perks
  'perks.posts': 'Beiträge',
  'perks.videos': 'Videos',
  'perks.merch': 'Merch',
  'perks.codes': 'Codes',
  'perks.music': 'Musik',
  'perks.recentPosts': 'Neueste Beiträge',
  'perks.myAccount': 'Mein Konto',
  'perks.logout': 'Abmelden',
  'perks.noActiveMemberships': 'Keine aktiven Mitgliedschaften.',
  'perks.generating': 'Wird generiert...',
  'perks.noCodesFound': 'Keine Codes gefunden',
  'perks.noProducts': 'Keine Produkte',
  'perks.foundFor': 'gefunden für "{query}"',
  'perks.more': 'Mehr',
  'perks.join': 'Beitreten',
  'perks.collectibles': 'Sammlerstücke',
  'perks.popularPosts': 'Beliebte Beiträge',
  'perks.noPosts': 'Keine Beiträge',
  'perks.adjustFilters': 'Versuche deine Filter anzupassen oder schau bald wieder vorbei!',
  'perks.loadMorePosts': 'Mehr Beiträge laden',
  'perks.loadMore': 'Mehr laden',
  'perks.memberSince': 'Mitglied seit',
  'perks.continueReading': 'Weiterlesen',
  'perks.joinToContinueReading': 'Beitreten um weiterzulesen',
  'perks.beFirstToComment': 'Sei der Erste, der einen Kommentar hinterlässt!',
  'perks.addComment': 'Kommentar hinzufügen...',
  'perks.addCommentButton': 'Kommentar hinzufügen',
  'perks.joinToComment': 'Beitreten um zu kommentieren',
  'perks.commentRemoved': '[ entfernt ]',
  'perks.commentHasBeenRemoved': 'Kommentar wurde entfernt.',
  'perks.reply': 'Antworten',
  'perks.replyToComment': 'Kommentar beantworten...',
  'perks.viewReplies': 'Antworten anzeigen',
  'perks.loadMoreReplies': 'Mehr Antworten laden',
  'perks.replyCount.one': '1 Antwort',
  'perks.replyCount.other': '{count} Antworten',
  'perks.filterPosts': 'Beiträge filtern',
  'perks.postType': 'Beitragstyp',
  'perks.postTypeText': 'Text',
  'perks.postTypeImages': 'Bilder',
  'perks.postTypeVideos': 'Videos',
  'perks.postTypeProducts': 'Produkte',
  'perks.postTypeAudio': 'Audio',
  'a11y.play': 'Abspielen',
  'a11y.pause': 'Pause',
  'a11y.seek': 'Fortschritt',
  'a11y.audioArtwork': 'Audio-Cover',
  'a11y.trackArtwork': 'Cover von {title}',
  'a11y.viewArtwork': 'Cover ansehen',
  'perks.tags': 'Tags',
  'perks.authors': 'Autoren',
  'perks.submission.submitPost': 'Beitrag einreichen',
  'perks.submission.createPost': 'Beitrag erstellen',
  'perks.submission.postingAs': 'Posten als',
  'perks.submission.loginRequired': 'Melde dich bei deinem Konto an, um einen Beitrag zu teilen.',
  'perks.submission.titleLabel': 'Titel',
  'perks.submission.titlePlaceholder': 'Gib deinem Beitrag einen Titel',
  'perks.submission.captionLabel': 'Bildunterschrift',
  'perks.submission.captionPlaceholder': 'Bildunterschrift hinzufügen',
  'perks.submission.addImage': 'Foto hinzufügen',
  'perks.submission.changeImage': 'Foto ändern',
  'perks.submission.uploading': 'Wird hochgeladen...',
  'perks.submission.submit': 'Zur Prüfung einreichen',
  'perks.submission.submitting': 'Wird eingereicht...',
  'perks.submission.post': 'Posten',
  'perks.submission.posting': 'Wird gepostet...',
  'perks.submission.postAnother': 'Weiteren Beitrag posten',
  'perks.submission.success': 'Eingereicht! Dein Beitrag wartet auf die Prüfung.',
  'perks.submission.successPublished': 'Dein Beitrag ist online.',
  'perks.submission.submitAnother': 'Weiteren Beitrag einreichen',
  'perks.submission.invalidImageType': 'Bitte wähle ein Bild im JPG-, PNG- oder GIF-Format.',
  'perks.submission.invalidImageSize': 'Bilder müssen kleiner als 25 MB sein.',
  'perks.submission.errorUploadImage':
    'Beim Hochladen deines Bildes ist ein Fehler aufgetreten. Bitte versuche es erneut.',
  'perks.submission.errorSubmit':
    'Beim Einreichen deines Beitrags ist ein Fehler aufgetreten. Bitte versuche es erneut.',
  'perks.submission.errorLimit': 'Einreichungslimit erreicht. Versuche es morgen erneut.',
  'perks.submission.errorUsername': 'Benutzername ist für Einreichungen nicht verfügbar',
  'perks.submission.removeImage': 'Foto entfernen',
  'perks.badge.artist': 'Verifiziert',
  'perks.badge.team': 'Team',
  'perks.shadowBanned': 'Shadowban: Nur dieser Fan und Moderatoren sehen das. Aufheben im Single-Dashboard unter Posts > Einstellungen.',
  'perks.artistProfileManaged': 'Dein Künstlerprofil wird im Single-Dashboard verwaltet',
  'perks.clearAll': 'Alle löschen',
  'perks.applyFilters': 'Filter anwenden',
  'perks.backToFeed': '← Zurück zum Feed',
  'perks.backToLibrary': '← Zurück zur Bibliothek',
  'music.album': 'Album',
  'music.download': 'Herunterladen',
  'music.loginToDownload': 'Zum Herunterladen anmelden',
  'music.linkExpired': 'Dieser Link ist abgelaufen.',
  'music.loginToAccess':
    'Bitte melden Sie sich mit der E-Mail-Adresse an, die Sie beim Kauf angegeben haben, um zu hören oder herunterzuladen.',
  'perks.noVideos': 'Keine Videos',
  'perks.noMusic': 'Keine Musik',
  'perks.gridView': 'Rasteransicht',
  'perks.listView': 'Listenansicht',
  'perks.oops': 'Hoppla!',
  'perks.notFound': '404: Not Found',
  'perks.goBack': 'Zurück',
  'perks.account': 'Konto',
  'perks.displayName': 'Anzeigename',
  'perks.emailPreferences': 'E-Mail-Einstellungen',
  'perks.emailPreference.POST_NOTIFICATIONS': 'Neue Beiträge',
  'perks.emailPreference.POST_NOTIFICATIONS.description':
    'Erhalte eine E-Mail, wenn ein neuer Beitrag veröffentlicht wird.',
  'perks.emailPreference.COMMENT_NOTIFICATIONS': 'Kommentare und Antworten',
  'perks.emailPreference.COMMENT_NOTIFICATIONS.description':
    'Erhalte eine E-Mail, wenn jemand auf deinen Kommentar antwortet.',
  'perks.emailPreference.COMMENT_NOTIFICATIONS.description.submissions':
    'Erhalte eine E-Mail, wenn jemand auf deinen Kommentar antwortet oder einen von dir eingereichten Beitrag kommentiert.',
  'perks.emailPreference.COMMENT_NOTIFICATIONS.description.author':
    'Erhalte eine E-Mail, wenn jemand auf deinen Kommentar antwortet oder einen von dir veröffentlichten Beitrag kommentiert.',
  'perks.comments': 'Kommentare',
  'perks.view': 'Ansehen',
  'perks.transfer': 'Übertragen',
  'perks.logInToViewCollectibles': 'Anmelden um Sammlerstücke anzusehen',
  'perks.viewAll': 'Alle ansehen',
  'perks.errorUploadAvatar': 'Avatar konnte nicht hochgeladen werden. Bitte versuche es erneut.',
  'perks.profileCardTitle': 'Willkommen! Lass uns dein Mitgliederprofil vervollständigen.',
  'perks.walletCardTitle': 'Lade deine Mitgliedskarte herunter',
  'perks.walletPassDescription':
    'Dein Mitgliederpass ist eine digitale Clubkarte für dein Apple- oder Android-Gerät. Er wird dir besondere Vorteile bei Shows und IRL gewähren.',
  'perks.walletScanDescription':
    'Scanne den QR-Code mit deinem Handy, um deinen Pass herunterzuladen.',
  'perks.updatingProfile': 'Wird aktualisiert...',
  'perks.updateProfile': 'Profil aktualisieren',
  'perks.displayNamePlaceholder': 'Gib hier deinen Namen ein...',
  'perks.usernamePlaceholder': 'Benutzername',
  'perks.profileVisibilityNote':
    'Nur dein Avatar und dein Anzeigename sind für andere Mitglieder sichtbar.',
  'perks.trackCount': '{count} Titel',
  'perks.trackCountOne': '{count} Titel',
  'perks.commentCount': '{count} Kommentare',
  'perks.commentCountOne': '{count} Kommentar',
  'perks.replyingTo': 'Antwort an @{name}',
  'perks.postCommentButton': 'Posten',
  'perks.avatarAlt': 'Avatar von {name}',
  'perks.hiddenPostImageAlt': 'Bild eines verborgenen Beitrags',
  'perks.postImageAlt': 'Beitragsbild',
  'perks.imageSlideAlt': 'Bild-Slide',
  'perks.videoThumbnailAlt': 'Video-Vorschaubild',
  'perks.productImageAlt': 'Produkt',
  'perks.membershipImageAlt': 'Mitgliedschaftsbild',
  'perks.tierImageAlt': 'Stufenbild',
  'perks.authorImageAlt': 'Autorenbild',
  'perks.submission.previewAlt': 'Vorschau der Einreichung',
  'a11y.countryCode': 'Ländervorwahl',
  'a11y.dismiss': 'Schließen',

  // Address Modal
  'address.updateAddress': 'Adresse aktualisieren',
  'address.firstName': 'Vorname',
  'address.lastName': 'Nachname',
  'address.street': 'Straße',
  'address.streetLine2': 'Adresszeile 2',
  'address.city': 'Stadt',
  'address.country': 'Land',
  'address.province': 'Bundesland',
  'address.zip': 'Postleitzahl',
  'address.phoneNumber': 'Telefonnummer',
  'address.update': 'Aktualisieren',
  'address.updating': 'Wird aktualisiert...',
  'address.errorStreetRequired': 'Straße ist erforderlich',
  'address.errorCountryRequired': 'Land ist erforderlich',
  'address.errorZipRequired': 'Postleitzahl ist erforderlich',
  'address.errorPhoneRequired': 'Telefonnummer ist erforderlich',

  // Common
  'common.cancel': 'Abbrechen',
  'common.ok': 'Ok',
  'common.close': 'Schließen',
  'common.dialog': 'Dialog',
  'a11y.communityNav': 'Community-Seiten',
  'a11y.likePost': 'Beitrag liken',
  'a11y.unlikePost': 'Like entfernen',
  'a11y.viewComments': 'Kommentare anzeigen',
  'a11y.previousSlide': 'Vorheriges Bild',
  'a11y.nextSlide': 'Nächstes Bild',
  'a11y.goToSlide': 'Zu Bild {number} wechseln',
  'a11y.collapseComment': 'Kommentar einklappen',
  'a11y.expandComment': 'Kommentar ausklappen',
  'a11y.commentMenu': 'Kommentaroptionen',
  'a11y.deleteComment': 'Kommentar löschen',
  'a11y.likeComment': 'Kommentar liken',
  'a11y.unlikeComment': 'Like entfernen',
  'a11y.reply': 'Antworten',
  'a11y.closeReplies': 'Antworten schließen',
  'a11y.backToFeed': 'Zurück zum Feed',
  'a11y.uploadAvatar': 'Avatar hochladen',
  'common.searchByTitle': 'Nach Titel suchen',
  'common.search': 'Suchen',
  'common.clear': 'Löschen',
  'common.error': 'Fehler',
  'common.save': 'Speichern',
  'common.saving': 'Wird gespeichert...',
  'common.edit': 'Bearbeiten',
  'common.delete': 'Löschen',
  'common.loading': 'Wird geladen...',
  'common.uploading': 'Wird hochgeladen...',
  'common.readMore': 'mehr lesen',
  'common.readLess': 'weniger lesen',
  'common.share': 'Teilen',
  'common.copied': 'Kopiert!',
  'common.browserShareError':
    'Dein Browser unterstützt keine Teilen- oder Zwischenablage-Funktionen.',
  'common.alreadyMember': 'Bereits Mitglied?',

  // Membership
  'membership.confirm': 'Bestätigen',
  'membership.nevermind': 'Egal',
  'membership.noGoBack': 'Nein, Zurück',
  'membership.yesCancel': 'Ja, Abbrechen',
  'membership.goBack': 'Zurück',
  'membership.continue': 'Weiter',
  'membership.confirmChange': 'Änderung bestätigen',
  'membership.termsAndConditions': 'Allgemeine Geschäftsbedingungen',
  'membership.updateBillingTerms': 'Abrechnungsbedingungen aktualisieren',
  'membership.confirmYourChanges': 'Änderungen bestätigen',
  'membership.confirmUpgrade': 'Upgrade bestätigen',
  'membership.confirmDowngrade': 'Downgrade bestätigen',
  'membership.termChange': 'Laufzeitänderung',
  'membership.labelCancellation': '{label} Kündigung',
  'membership.cancelPendingTitle': '{change} abbrechen',
  'membership.yesCancelPending': 'Ja, {change} abbrechen',
  'membership.revertSettings': 'Dein {label} wird auf die vorherigen Einstellungen zurückgesetzt.',
  'membership.cancelTitle': '{label} kündigen',
  'membership.areYouSureCancel': 'Möchtest du wirklich kündigen?',
  'membership.cancellationEndOfTerm': 'Deine Kündigung tritt am Ende deiner Laufzeit in Kraft.',
  'membership.stillHaveAccess':
    'Du hast jedoch weiterhin Zugang zu deinem bezahlten {label} für den Rest deiner Laufzeit.',
  'membership.expirationDate': '{label} Ablaufdatum:',
  'membership.notice': 'Hinweis:',
  'membership.cancellationNotice':
    '{label}-Kündigungen treten erst am Ende deiner Laufzeit in Kraft.',
  'membership.contactForQuestions': 'Bei Fragen zur Kündigung deines {label} wende dich bitte an',
  'membership.contactIfUnsure':
    'Wenn du unsicher bist, ob dies auf deine spezifische Bestellung zutrifft, wende dich bitte an den Kundendienst.',
  'membership.cancelMembershipButton': 'Mitgliedschaft kündigen',
  'membership.currentPlan': 'Aktueller Plan',
  'membership.newPlan': 'Neuer Plan',
  'membership.newPlanStarts': 'Dein neuer Plan beginnt am',
  'membership.newTierTerm': 'Neuer Stufenbegriff:',
  'membership.nextBillingDateLabel': 'Nächstes Abrechnungsdatum:',
  'membership.perMonth': '/Monat',
  'membership.aboutToUpgrade': 'Du bist dabei, deine Mitgliedschaftsstufe zu upgraden.',
  'membership.aboutToDowngrade': 'Du bist dabei, deine Mitgliedschaftsstufe downzugraden.',
  'membership.viewMyPerks': 'Meine Vorteile ansehen',
  'membership.manage': 'Verwalten',
  'membership.joining': 'Beitritt läuft...',
  'membership.join': 'Beitreten',
  'membership.addingToCart': 'Zum Warenkorb hinzufügen...',
  'membership.upgrade': 'Upgraden',
  'membership.downgrade': 'Downgraden',
  'membership.cancelPendingChanges': 'Ausstehende Änderungen abbrechen',
  'membership.active': 'Aktiv',
  'membership.nextBillingDate': 'Nächste Abrechnung',
  'membership.term': 'Laufzeit',
  'membership.changeTerm': '(ändern)',
  'membership.price': 'Preis',
  'membership.free': 'KOSTENLOS',
  'membership.per': 'pro',
  'membership.oneTimePurchase': 'Einmaliger Kauf',
  'membership.noMembershipsAvailable': 'Keine Mitgliedschaften verfügbar',
  'membership.transactionFailed': '{label}-Transaktion fehlgeschlagen - Klicken zum Aktualisieren',
  'membership.noActiveMemberships': 'Keine aktiven Mitgliedschaften',
  'membership.pending': 'Ausstehend',
  'membership.cancellation': 'Kündigung',
  'membership.upgradeDowngrade': 'Upgrade / Downgrade',
  'membership.cancelLink': 'Abbrechen',
  'membership.nextShipment': 'Nächste Lieferung •',
  'membership.viewProduct': 'Produkt ansehen',
  'membership.hasBeenScheduled': 'wurde geplant.',
  'membership.changingTo': 'Wechselt zu:',
  'membership.willBeDowngradedTo': 'Dein {label} wird herabgestuft auf',
  'membership.on': 'am',
  'membership.stillHaveAccessUntil': 'Du hast noch Zugang bis',
  'membership.cancelChange': 'Änderung abbrechen',
  'membership.nextBilling': 'Nächste Abrechnung',
  'membership.subscriptionShipMonthly': 'Abonnementbestellungen werden monatlich versendet.',
  'membership.noUpcomingBillDates': 'Keine bevorstehenden Abrechnungsdaten.',
  'membership.orderHistory': 'Bestellhistorie',
  'membership.emailWithTracking':
    'Du erhältst eine E-Mail mit Tracking, sobald deine Bestellung versandt wurde.',
  'membership.back': '← Zurück',
  'membership.shippingAddress': 'Lieferadresse',
  'membership.missingAddress': 'Adressinformationen fehlen. Zum Aktualisieren klicken.',
  'membership.editShippingAddress': 'Lieferadresse bearbeiten',
  'membership.paymentMethod': 'Zahlungsmethode',
  'membership.updatePaymentInstructions':
    'Um deine Zahlungsmethode zu aktualisieren, verwende den Link unten. Eine E-Mail mit Anweisungen wird an dich gesendet.',
  'membership.updatePaymentMethod': 'Zahlungsmethode aktualisieren',
  'membership.paymentFailed': 'Zahlung fehlgeschlagen',
  'membership.productImageAlt': 'Produktbild',
  'membership.detailMembership': 'Mitgliedschaft',
  'membership.detailBilling': 'Abrechnung',
  'membership.detailPlan': 'Tarif',
  'membership.detailMemberId': 'Mitglieds-ID',
  'membership.detailSubscriptionNumber': 'Abonnement-Nr.',
  'membership.detailStatus': 'Status',
  'membership.detailTerms': 'Laufzeit',
  'membership.detailLastPayment': 'Letzte Zahlung',
  'membership.receivedOn': 'Eingegangen am {date}',
  'membership.receivedAmountOn': '{amount} eingegangen am {date}',
  'membership.detailName': 'Name',
  'membership.detailStreet': 'Straße',
  'membership.detailCity': 'Stadt',
  'membership.detailState': 'Bundesland',
  'membership.detailZip': 'PLZ',
  'membership.detailCountry': 'Land',
  'membership.detailPhone': 'Telefon',
  'membership.detailCard': 'Karte',
  'membership.detailNumber': 'Nummer',
  'membership.detailExpires': 'Gültig bis',
  'membership.detailMethod': 'Methode',
  'membership.manageLabel': '{label} verwalten',

  // Music
  'music.exclusive': 'Exklusiv',
  'music.trackTitle': 'Titel',
  'music.songCount': '{count} Songs',
  'music.songCountOne': '{count} Song',
  'music.allTracksAvailableIn': 'ALLE TITEL VERFÜGBAR IN:',
  'music.preorderUnlock': 'Jetzt vorbestellen und ab dem {date} streamen oder herunterladen.',
  'music.downloadUnavailable': 'Download nicht verfügbar',
  'music.downloadLimitReached': 'Du hast das Download-Limit erreicht. Bitte kontaktiere den Shop.',
  'music.downloadFailed': 'Download fehlgeschlagen. Bitte versuche es erneut.',
  'music.downloadNotAllowed': 'Melde dich mit der E-Mail-Adresse an, mit der du gekauft hast.',
  'music.downloadCodeUnavailable': 'Dieser Download ist nicht verfügbar. Bitte kontaktiere den Shop.',
  'music.downloadStarted': 'Download gestartet',
  'music.downloadStartedHint': 'Sieh in deinen Downloads oder in der Dateien-App nach.',
  'music.openInBrowserTitle': 'Download blockiert',
  'music.openInBrowserBody':
    'Der In-App-Browser, den du verwendest, blockiert Downloads. Du musst diese Seite in einem externen Browser öffnen.',
  'music.openInBrowserHint':
    'Tippe auf das •••-Symbol und wähle „Im externen Browser öffnen“, um fortzufahren.',
  'music.demoArtist': 'Testkünstler',
  'music.demoAlbum': 'Demo-Album',
  'music.demoTrack': 'Titel {n}',
  'a11y.previousTrack': 'Vorheriger Titel',
  'a11y.nextTrack': 'Nächster Titel',
  'a11y.playAll': 'Alle abspielen',

  // Video
  'video.startsIn': 'Beginnt in:',
  'video.previewTitle': 'Videotitel',
  'video.previewArtist': 'Künstlername',
  'video.previewDescription': 'Videobeschreibung',
};
